import { render, staticRenderFns } from "./DialogBibleTranslation.vue?vue&type=template&id=2ef5f7ac&scoped=true"
import script from "./DialogBibleTranslation.vue?vue&type=script&lang=js"
export * from "./DialogBibleTranslation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ef5f7ac",
  null
  
)

export default component.exports